import { useSelector } from 'react-redux';
import { authSelector } from '../../store';

export type HasPermissionFn = (requiredPermissions?: string[]) => boolean;

interface UsePermissionInterface {
  hasPermission: HasPermissionFn;
  hasNavAccess: (requiredPermissions?: string[], requiredRoles?: readonly string[]) => boolean;
}

export const usePermission = (): UsePermissionInterface => {
  const {
    data: { privileges, roleValue },
  } = useSelector(authSelector);

  const hasPermission: HasPermissionFn = (requiredPermissions) => {
    if (requiredPermissions) {
      for (const requiredPermission of requiredPermissions) {
        if (privileges?.includes(requiredPermission)) {
          return true;
        }
      }
      return false;
    }
    return true;
  };

  const hasNavAccess = (requiredPermissions?: string[], requiredRoles?: readonly string[]) => {
    if (requiredRoles?.includes(roleValue)) {
      return true;
    }

    return hasPermission(requiredPermissions);
  };

  return {
    hasPermission,
    hasNavAccess,
  };
};
